export const loginContainer = 'h-full mt-14 p-4 pt-0 z-10';
export const wrapper = 'min-h-full bg-white flex flex-1 flex-col';
